import React, { FunctionComponent } from 'react';

import {
  default as MuiIconButton,
  IconButtonProps,
} from '@mui/material/IconButton';

const IconButton: FunctionComponent<IconButtonProps> = ({
  children,
  disableRipple,
  onClick,
  sx,
}: IconButtonProps) => {
  return (
    <MuiIconButton disableRipple={disableRipple} onClick={onClick} sx={sx}>
      {children}
    </MuiIconButton>
  );
};
export default IconButton;
